import { QIcon_star_filled } from '@repo/icons/index'
import classNames from 'classnames'
import { COLORS, MAX_RATING } from '../../modules/vars'

interface StarsProps {
  stars: number
  clx?: string
  activeColor?: (typeof COLORS)[keyof typeof COLORS]
  defaultColor?: (typeof COLORS)[keyof typeof COLORS]
  width?: number
  height?: number
}

const Stars = ({
  stars,
  clx,
  activeColor = COLORS.PURPLE500,
  defaultColor = COLORS.GRAY200,
  width = 24,
  height = 24,
}: StarsProps) => {
  if (stars >= MAX_RATING) {
    stars = MAX_RATING
  }
  const full = Math.floor(stars)
  const empty = MAX_RATING - full

  return (
    <>
      <div className={classNames(clx, 'text-purple-500')}>
        {Array(full)
          .fill(0)
          .map((_, i) => (
            <QIcon_star_filled key={`full-${i}`} color={activeColor} width={width} height={height} />
          ))}
        {Array(empty)
          .fill(0)
          .map((_, i) => (
            <QIcon_star_filled key={`empty-${i}`} color={defaultColor} width={width} height={height} />
          ))}
      </div>
    </>
  )
}

export default Stars
